import { S3_BUCKET_URL, GIRLS_CATEGORY } from '@/constants';

import { BODY_SHAPE_OPTIONS } from '../../options/BodyShape/BODY_SHAPE_OPTIONS';
import { BREAST_SIZE_OPTIONS } from '../../options/BreastSize/BREAST_SIZE_OPTIONS';
import { BUTT_SIZE_OPTIONS } from '../../options/ButtSize/BUTT_SIZE_OPTIONS';
import { ScreenBodyShape } from '../OwnAI/screens/BodyShape';
import { ScreenCommunicate } from '../OwnAI/screens/Communicate';
import { ScreenName } from '../OwnAI/screens/Name';
import { ScreenPersonality } from '../OwnAI/screens/Personality';
import { ScreenSecurity } from '../OwnAI/screens/Security';
import { ScreenSettingUpProfile } from '../OwnAI/screens/SettingUpProfile';

import { ScreenBreastSize } from './screens/BreastSize';
import { ScreenButtSize } from './screens/ButtSize';
import { ScreenEmail } from './screens/Email';
import { ScreenFindAi } from './screens/FindAi';
import { ScreenSendPhoto } from './screens/SendPhoto';
import { ScreenSendVideo } from './screens/SendVideo';
import { WelcomeScreen } from './screens/Welcome';
import { LayoutDataType } from './types';

export const layoutSteps = {
  welcome: {
    component: WelcomeScreen,
    images: [],
  },
  body_shape: {
    component: ScreenBodyShape,
    images: BODY_SHAPE_OPTIONS.map(
      (option) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/layout-own-ai/body_shape/${option.id}.png`,
    ),
  },
  breast_size: {
    component: ScreenBreastSize,
    images: BREAST_SIZE_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/layout-own-ai-ons/breast-size/${option.id}.jpg`,
    ),
  },
  butt_size: {
    component: ScreenButtSize,
    images: BUTT_SIZE_OPTIONS.map(
      (option) =>
        `${S3_BUCKET_URL}/layout-own-ai-ons/butt-size/${option.id}.jpg`,
    ),
  },
  find_ai: {
    component: ScreenFindAi,
    images: [
      `${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-1.png`,
      `${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-2.png`,
      `${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-3.png`,
      `${S3_BUCKET_URL}/layout-own-ai-ons/find-ai/girl-4.png`,
    ],
  },
  communicate: {
    component: ScreenCommunicate,
    images: [],
  },
  personality: {
    component: ScreenPersonality,
    images: [],
  },
  send_video: {
    component: ScreenSendVideo,
    images: [`${S3_BUCKET_URL}/layout-own-ai-ons/send-video/bg.webp`],
  },
  send_photo: {
    component: ScreenSendPhoto,
    images: [`${S3_BUCKET_URL}/layout-own-ai-ons/send-photos/bg.png`],
  },
  security: {
    component: ScreenSecurity,
    images: [],
  },
  name: {
    component: ScreenName,
    images: [],
  },
  setting_up_profile: {
    component: ScreenSettingUpProfile,
    images: [],
  },
  email: {
    component: ScreenEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  body_shape: null,
  breast_size: null,
  butt_size: null,
  communicate: null,
  personality: {
    shy_dominant: 50,
    serious_flirty: 50,
    logical_emotional: 50,
    affectionate_independent: 50,
  },
  send_videos: null,
  send_photos: null,
  name: '',
  characters: [],
  email: '',
};

// GIRLS CATEGORIES
export const HARDCODED_CATEGORIES = [GIRLS_CATEGORY];
